module.exports = __webpack_public_path__ + "img/bg_valentine.f5116817.jpg";